<div class="dialog">
  <button mat-button mat-dialog-close class="dialog__close" type="button" (click)="onClose()">
    <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon>
    <span>{{translatedData.close}}</span>
  </button>
  <div mat-dialog-title class="mat-dialog-title">
    <header>{{translatedData.selectAttachment}}</header>
  </div>
  <form>
    <div mat-dialog-content class="content">
      @if (images.length ) {
        <div class="mediaInfo">
          @for (media of images; track media) {
            <div>
              <div class="media-block">
                <div class="image-block">
                  <div class="container">
                    <div
                      miq-bg-image
                      [imageSrc]="media.sanitized_media_path"
                      [publishable]="media.publishable"
                      color="image-container default"
                    ></div>
                  </div>
                </div>
                <div class="file-name-block">
                  <div class="media-select">
                    @if (multiSelect) {
                      <mat-checkbox
                        [id]="media?.id"
                        [name]="media?.media_name"
                        [(ngModel)]="media.checked"
                        (change)="selectImage()"
                        >
                        {{ media?.media_name }}
                      </mat-checkbox>
                    }
                    @if (!multiSelect) {
                      <mat-radio-button
                        [checked]="media.id === selectedMedia?.id"
                        class="radio-button"
                        (click)="selectImage(media)"
                        >
                        <span class="wrap-radion-button-label"> {{ media?.media_name }} </span>
                      </mat-radio-button>
                    }
                    <div class="caption">{{ media?.media_caption }}</div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="no-records">
          <!-- TODO: Need to add icon -->
          {{translatedData.noImagesFound}}
        </div>
      }

      <div mat-dialog-actions class="mat-dialog-actions">
        @if (navigationMessage) {
          <span class="navigationMessage" (click)="navigate()">
            {{translatedData.navigationMessage}}
            <mat-icon svgIcon="icon-upload" color="y-upload" class="mat-icon-upload"></mat-icon>
            <span class="add-new"> {{ translatedData.addNew }}</span>
          </span>
        }
        <span class="select-action">
          <button class="btn-submit" type="button" (click)="select()">{{translatedData.select}}</button>
        </span>
      </div>
    </div>
  </form>
</div>
